import { render, staticRenderFns } from "./ag-numeric-editor.vue?vue&type=template&id=08ee6b81&scoped=true"
import script from "./ag-numeric-editor.vue?vue&type=script&lang=js"
export * from "./ag-numeric-editor.vue?vue&type=script&lang=js"
import style0 from "./ag-numeric-editor.vue?vue&type=style&index=0&id=08ee6b81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee6b81",
  null
  
)

export default component.exports